import React from "react";

const TONES = {
  neutral: "bg-bg text-muted border-border",
  primary: "bg-primary-wash text-primary border-primary/20",
  success: "bg-success/10 text-success border-success/20",
  danger: "bg-danger/10 text-danger border-danger/20",
  gold: "bg-gold/15 text-[#8A6100] border-gold/30",
  navy: "bg-navy text-white border-navy",
};

// Tournament lifecycle. Kept here so the index and the detail page can never
// disagree about what "ongoing" looks like.
export const STATUS_TONE = {
  upcoming: "success",
  ongoing: "gold",
  completed: "navy",
};

// Solid fills, for badges that sit on top of a photo — the washed tones above
// are 10% opacity and vanish against a light image.
export const STATUS_SOLID = {
  upcoming: "bg-success text-white border-success",
  ongoing: "bg-gold text-navy border-gold",
  completed: "bg-navy text-white border-navy",
};

const Badge = ({ tone = "neutral", className = "", children }) => (
  <span
    className={`inline-flex items-center gap-1.5 rounded-full border px-2.5 py-1 text-xs font-semibold ${
      TONES[tone] ?? TONES.neutral
    } ${className}`}
  >
    {children}
  </span>
);

export default Badge;
